import { Platform } from 'react-native';
import i18n from '../../i18n';

export function translate(props) {
    var title = '';

    if (Array.isArray(props)) {
        title = i18n.t(props);
    } else if (typeof props === 'string') {
        title = props;
    } 
    
    return title;
}